export const CANVAS_CONFIG = {
  CELL_SIZE: 32,
  GRID_COLOR: "#333",
  BACKGROUND_COLOR: "#000",
  ID: "polygon"
};
export const STAGE_THRESHOLDS = {
  STAGE2_ACTIVATION: 3200,
  STAGE3_STAGE1_ACTIVATION: 9000,
  STAGE3_STAGE2_ACTIVATION: 25000
};
export const STAGE_DISABLED_HEIGHT = 10;

